<template>
  <Header />
  <div style="background-color: #f7f7f7; padding-bottom: 10px;">
    <div class="news-content">
      <div class="nav-link">
        当前位置：
        <router-link to="/">首页</router-link>
        &gt; 河南省测绘地理信息市场服务与监管平台专题
      </div>
      <div class="main-content">
        <img class="product-img" src="/img/henan_zt.jpg" alt="注册测绘师执业系统" />
      </div>
    </div>
  </div>
  <footer class="custom-footer">
    <div class="footer-content">
      <div class="footer-left">
        <p>欢迎关注</p>
        <p>微信公众号</p>
        <img src="/img/erwm01.jpg" alt="微信公众号" class="qrcode" />
      </div>
      <div class="footer-right">
        <p>公司地址：北京市海淀区莲花苑838室 平台服务热线：010-88614688</p>
        <p>人才招聘：010-88610601 商务合作：010-88619537</p>
      </div>
    </div>
  </footer>
  <div class="footer-copyright">
    <p>版权所有：北京四维安信软件科技有限公司|ICP备案号：京ICP备19009628号-1</p>
  </div>
</template>

<script setup>
import Header from "@/components/header.vue";
</script>

<style lang="scss" scoped>
.news-content {
  max-width: 1164px;
  width: 100%;
  border: 1px solid #eaeaea;
  margin: 0 auto;
  margin-top: 10px;
  background-color: #fff;

  .nav-link {
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    border-bottom: 1px solid #f8f8f8;

    a {
      color: #2a6fdb;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .main-content {
    padding: 16px 12px 24px;
  }

  .product-img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
  }
}

.custom-footer {
  background-color: #0a3a80;
  padding: 20px 0;

  .footer-content {
    max-width: 1164px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    gap: 80px;
    padding: 0 20px;
  }

  .footer-left {
    text-align: center;
    color: #fff;

    p {
      margin: 5px 0;
      font-size: 14px;
    }

    .qrcode {
      width: 120px;
      height: 120px;
      margin-top: 10px;
    }
  }

  .footer-right {
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
      margin: 10px 0;
      font-size: 14px;
      line-height: 1.6;
    }
  }
}

.footer-copyright {
  background-color: #000;
  padding: 15px 0;
  text-align: center;

  p {
    color: #fff;
    font-size: 12px;
    margin: 0;
  }
}
</style>